/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import ReactMarkdown from 'react-markdown';
import {
    string, bool, func, shape, object,
} from 'prop-types';

const styles = {
    contentContainer: {
        textAlign: 'center',
        '& p': {
            padding: '10px 10px',
            textAlign: 'left',
            width: '100%',
        },
        '& a': {
            display: 'block',
        },
        '& img': {
            width: '100%',
        },
    },
    closeIcon: {
        position: 'absolute',
        right: '1%',
        cursor: 'pointer',
    },
    dialogMain: {
        minWidth: 280,
    },
};

const WrapUpHoverModal = ({
    modalData, hoverModalClose, hoverModalOpen, classes, groupItemId,
}) => {
    const anchorGroupAddonsWrapup = () => {
        hoverModalClose();

        if (typeof window !== 'undefined' && document.querySelector(`div.addonwrap-${groupItemId}`)) {
            const element = document.querySelector(`div.addonwrap-${groupItemId}`);
            // Scroll the window until the position of the product  is not filled yet
            if (element?.scrollIntoView) {
                setTimeout(() => {
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'nearest',
                    });
                }, 300);
            }
        }
    };

    return (
        <Dialog
            open={hoverModalOpen}
            classes={{
                paperWidthSm: classes.dialogMain,
            }}
        >
            <DialogTitle>
                <Grid item className={classes.closeIconContainer}>
                    <CloseIcon className={classes.closeIcon} onClick={() => { anchorGroupAddonsWrapup(); }} />
                </Grid>
            </DialogTitle>
            <Grid container className={classes.contentContainer}>
                <ReactMarkdown escapeHtml={false} source={modalData?.info_on_hover} className={classes.moreMovies} />
            </Grid>
        </Dialog>
    );
};
WrapUpHoverModal.propTypes = {
    modalData: shape({
        info_on_hover: string.isRequired,
    }).isRequired,
    hoverModalClose: func.isRequired,
    hoverModalOpen: bool.isRequired,
    classes: object.isRequired,
    groupItemId: string.isRequired,
};

export default withStyles(styles)(WrapUpHoverModal);
